const React = require('react');
const withState = require('../../../utils/withState');
const TextField = require("../TextField/A");
const noop = require("mn-utils/noop");
const trim = require("mn-utils/trim");

module.exports = withState((setState, self, onMount) => {
  const arrayOfFields = new Array(self.props.codeLength || 1).fill('');

  return (state, props) => {
    const {
      label,
      error,
      helperText,
      codeLength,
      onChange = noop,
      onSubmit = noop
    } = props;

    return (
      <div className="rlv pb15">
        <div className="FieldE_Label mb14 f12 h12 lh fw4">{label}</div>
        <div className="layoutRow mt10 mh-10 (ph10)>1">
          {arrayOfFields.map((el, i) => (
            <div key={i}>
              <input
                className={
                  `code-field dB olc0 w40 h40 bgF b1 bs bc8 (bc0|olc0):f bcF00.error r9 tc ff$3`
                  + (error ? ' error' : '')
                }
                value={arrayOfFields[i] || ''}
                onFocus={() => {
                  const codeFieldsArr = document.getElementsByClassName('code-field');
                  const prevField = codeFieldsArr[i - 1];
                  if (prevField && !prevField.value) prevField.focus();
                }}
                onKeyDown={(e) => {
                  const key = e.key;
                  const codeFieldsArr = document.getElementsByClassName('code-field');

                  if (!['Enter', 'Backspace'].includes(key)) return;

                  if (key === 'Enter') {
                    codeFieldsArr[i].blur();
                    return onSubmit();
                  };

                  let nextFieldIndex = i;

                  if (key === 'Backspace') {
                    if (arrayOfFields[i]) {
                      arrayOfFields[i] = '';
                    } else {
                      arrayOfFields[i - 1] = '';
                      nextFieldIndex = i - 1;
                    }
                  }

                  onChange({target: {value: arrayOfFields.join('')}});

                  setTimeout(() => {
                    const nextField = codeFieldsArr[nextFieldIndex];
                    if (nextField) nextField.focus();
                  });
                }}
                onChange={(e) => {
                  let nextValue = trim(e.target.value || '');

                  if (isNaN(nextValue)) return;

                  if (nextValue.length >= codeLength) {
                    nextValue = nextValue.slice(0, codeLength);
                    nextValue.split('').forEach((key, i) => arrayOfFields[i] = key);
                  } else {
                    arrayOfFields[i] = nextValue.slice(-1);
                    nextValue = arrayOfFields.join('');
                  }

                  onChange({target: {value: nextValue}});

                  setTimeout(() => {
                    const codeFieldsArr = document.getElementsByClassName('code-field');
                    const nextField = codeFieldsArr[codeLength - 1];

                    if (nextField) nextField.focus();
                  })
                }}
              />
            </div>
          ))}
        </div>
        {
          error ? (
            <div
              className="abs sb0 sh-3 xY100% f11 cF00 fw4 wmin130"
            >{helperText || 'Invalid value'}</div>
          ) : null
        }
      </div>
    );
  }
})
